/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssignmentRuleRequest
 */
export interface CreateAssignmentRuleRequest {
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    source_id?: string;
    /**
     * 
     */
    connector?: string;
    /**
     * 
     */
    owner_user_id?: string;
    /**
     * 
     */
    liaison_user_ids?: Array<string>;
}

/**
 * Check if a given object implements the CreateAssignmentRuleRequest interface.
 */
export function instanceOfCreateAssignmentRuleRequest(value: object): value is CreateAssignmentRuleRequest {
    return true;
}

export function CreateAssignmentRuleRequestFromJSON(json: any): CreateAssignmentRuleRequest {
    return CreateAssignmentRuleRequestFromJSONTyped(json, false);
}

export function CreateAssignmentRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssignmentRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'source_id': json['source_id'] == null ? undefined : json['source_id'],
        'connector': json['connector'] == null ? undefined : json['connector'],
        'owner_user_id': json['owner_user_id'] == null ? undefined : json['owner_user_id'],
        'liaison_user_ids': json['liaison_user_ids'] == null ? undefined : json['liaison_user_ids'],
    };
}

export function CreateAssignmentRuleRequestToJSON(json: any): CreateAssignmentRuleRequest {
    return CreateAssignmentRuleRequestToJSONTyped(json, false);
}

export function CreateAssignmentRuleRequestToJSONTyped(value?: CreateAssignmentRuleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'source_id': value['source_id'],
        'connector': value['connector'],
        'owner_user_id': value['owner_user_id'],
        'liaison_user_ids': value['liaison_user_ids'],
    };
}

